export const theme = {
  white: "#ffffff",
  primary: "#ffc211",
  secondary: "#19274B",
  redDark: "#842323",
  red: "#A72626",
  pink: "#fdb4b4",
  yellow: "#fffbf0",
  orange: "#FFBD61",
  bgBlue: "#213450",
  gray: "#F4F4F4",
  pinkred: "#FF755A",
  CTAcolor: "#E84138",
  CTAcolorLinear: "linear-gradient(270deg, #FCB43F, #FC3F3F)",
  CTAcolorButton: "linear-gradient(270deg, #FCB43F, #FC3F3F, #E84138)",
  orangLinearTop: "linear-gradient(180deg, #f3e4cc, #FFD9A3)",
  StrongBgLinearTop: "linear-gradient(0deg, #C7FCFF, #FFF6CE)",
  StrongBgLinearBottom: "linear-gradient(180deg, #C7FCFF, #FFF6CE)",
  bgLinearTop: "linear-gradient(to bottom, #eefeff, #fffcf1)",
  bgLinearBottom: "linear-gradient(to top, #eefeff, #fffcf1)",
  bgLinearDeepBottom: "linear-gradient(to bottom, #E6FAFB, #fffcf1)",
  bgBlue: "#EEFEFF",
  bgBlueText: "#D6EDEE",
  bgBlueText: "#E6FAFB",
  titleFonts: '"Barlow", "Noto Sans TC", sans-serif',

  sm: "max-width:640px",
  md: "max-width:768px",
  lg: "max-width:1024px",
  xl: "max-width:1280px",
  xxl: "max-width:1400px"
}
